import { DescriptionText, H1Text, H2Text, Hr } from "../../../../design";
import React from "react";
import { Col, Row } from "react-awesome-styled-grid";
import { REFRENCE_ID_LENGTH } from "../../../../appconstants";
import { AmountDivideByHundred } from "../../../../helper";
import SmallScreenHeader from "../../../../components/smallscreen/header";
import currencyFormatter from "../../../../utils/currencyformatter";

type Props = {
  payment: Object,
  tabName: String,
  bankImageUrl: String,
}

const Header = (props: Props) => {
  const { payment, tabName, bankImageUrl } = props;
  const largeLogo = (payment && payment.account && payment.account.largeLogo) ? payment.account.largeLogo : null;
  return (
    <SmallScreenHeader paymentCheckout={true} bankImageUrl={bankImageUrl} largeLogo={largeLogo}>
      <H1Text>
        Payment Checkout
      </H1Text>
      <Hr marginTop="0px" />
      <div className="mb-4 mt-4" style={{ fontWeight: '400', fontSize: '14px', color: '#909090' }}>
        Payment For
      </div>
      <Row>
        <Col className="mt-0" style={{ fontWeight: '600', fontSize: '18px', color: '#1B1B1B' }}>
          {(payment && payment.description) || (payment && payment.account && payment.account.name)}
        </Col>
      </Row>
      <div className="mt-2 mb-4" style={{ fontWeight: '400', fontSize: '13px', color: '#474747' }}>
        <p>
          Reference Id: {
            (payment && payment.gid) ? (payment.gid).slice(-REFRENCE_ID_LENGTH) : <>&#8211;</>
          }
        </p>
      </div>
      {
        tabName === 'UPI' && (
          <>
            <H2Text>
              Amount
            </H2Text>
            <DescriptionText>
              {payment ? `${currencyFormatter(AmountDivideByHundred(payment.amount), payment.currency && payment.currency.name)}` : null}
            </DescriptionText>
          </>
        )
      }
    </SmallScreenHeader>
  )
};

export default Header;
